import React, { useState, useEffect } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { useQuery } from "react-query";
import { searchClients } from "../../../api/services/Client";
import { QK } from "../../../base/qk";

const ClientMultiSelect = ({ label, value = [], onChange, required = false }) => {
  const [inputValue, setInputValue] = useState("");
  const [optionsList, setOptionsList] = useState([]);

  const { data: options = [], isFetching } = useQuery(
    [QK.clients, inputValue],
    () => searchClients(inputValue),
    {
      enabled: !!inputValue,
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    if (value.length > 0) {
      const notIncluded = value.filter(
        (v) => !options.some((o) => o.id === v.id)
      );
      setOptionsList([...notIncluded, ...options]);
    } else {
      setOptionsList(options);
    }
  }, [options, value]);

  const getOptionLabel = (option) => {
    if (!option) return "";
    return `${option.first_name} ${option.last_name} (${option.area_name || "No Area"})`;
  };

  return (
    <Autocomplete
      multiple
      options={optionsList}
      getOptionLabel={getOptionLabel}
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      inputValue={inputValue}
      onInputChange={(e, v) => setInputValue(v)}
      isOptionEqualToValue={(option, val) => option.id === val?.id}
      loading={isFetching}
      noOptionsText={
        inputValue.length > 0
          ? "No service users match your search"
          : "Type to search service users"
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isFetching ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ClientMultiSelect;